"use client";

import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import { ProjectCardSkeleton } from "../card";

interface ProjectsEmptyNoResultsProps {
  hasFilters: boolean;
  onClearFilters: () => void;
}

export function ProjectsEmptyNoResults({
  hasFilters,
  onClearFilters,
}: ProjectsEmptyNoResultsProps) {
  return (
    <div className="relative h-full overflow-hidden">
      <div
        className="pointer-events-none grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-6 p-page opacity-[0.3] select-none"
        aria-hidden="true"
        role="presentation"
      >
        {Array.from({ length: 12 }).map((_, i) => (
          <ProjectCardSkeleton key={i} index={i} />
        ))}
      </div>

      <section
        role="status"
        aria-labelledby="projects-no-results-heading"
        className="absolute inset-0 flex flex-col items-center justify-center gap-3 text-center px-8"
      >
        <div
          aria-hidden="true"
          className="flex size-14 items-center justify-center rounded-xl border border-border bg-surface-inset backdrop-blur-sm"
        >
          <Icon
            name="IconFolderBookmarks"
            size={24}
            className="text-heading opacity-30"
          />
        </div>
        <div className="flex flex-col gap-1">
          <h2
            id="projects-no-results-heading"
            className="text-[15px] font-medium text-heading"
          >
            No matching projects
          </h2>
          <p className="text-[13px] text-contrast/50 max-w-[360px]">
            Try adjusting your filters or search query.
          </p>
        </div>
        {hasFilters && (
          <Button
            type="button"
            variant="secondary"
            size="sm"
            onClick={onClearFilters}
            icon={<Icon name="IconCrossMedium" size={10} />}
          >
            Clear all filters
          </Button>
        )}
      </section>
    </div>
  );
}
